"use client"

import ChevronIcon from "./ChevronIcon"
import { ArrowButton } from "./modelShowcase.styled"

type Props = {
  direction: "prev" | "next"
  onClick: () => void
  ariaLabel: string
}

const NavArrow = ({ direction, onClick, ariaLabel }: Props) => (
  <ArrowButton type="button" $direction={direction} onClick={onClick} aria-label={ariaLabel}>
    <ChevronIcon size={18} />
  </ArrowButton>
)

export default NavArrow
